import type { State, Column, RequestsColumnSettingsState } from './types';

/**
 * Request column settings selectors for accessing column configuration.
 * These selectors are designed to avoid cyclic dependencies.
 */

/**
 * Get the full requests column settings state (includes columns and statusFilter).
 */
const getRequestsColumnSettingsState = (state: State): RequestsColumnSettingsState => {
    return state.persisted.requestsColumnSettings || { columns: [], statusFilter: undefined };
};

/**
 * Get just the columns array from requests column settings.
 * This maintains backwards compatibility - consumers that expect Column[] will continue to work.
 */
export const getRequestsColumnSettings = (state: State): Column[] => {
    const settingsState = getRequestsColumnSettingsState(state);
    return settingsState.columns || [];
};
